export * from './trim.module';
export * from './trim.directive';
